import { StatsigClient } from '@statsig/js-client';

import Environment from './Environment';

const client = new StatsigClient(
  Environment.getStatsigKey,
  {},
  { environment: { tier: Environment.getStatsigEnvironment } }, // (optional) Configure SDK via StatsigOptions here
);

/* Once, at module load. Never call initializeAsync again from a component — a
   second call resets the store to 'Loading' and refetches, so every read in that
   window falls back. The catch keeps a failed init from surfacing as an unhandled
   rejection; reads answer with their fallbacks either way. */
client.initializeAsync().catch(() => {});

const Features = {
  checkGate: (featureName) => client.checkGate(featureName),
  logEvent: (eventName, metadata) => client.logEvent(eventName, metadata),
  getConfig: (configName) => client.getDynamicConfig(configName),
  updateUserAsync: (user, options = {}) =>
    client.updateUserAsync(user, options),
  getClient: () => client,
  getExperiment: (experimentName, options) =>
    client.getExperiment(experimentName, options),

  featureIsEnabled: (featureName) => {
    return client.checkGate(featureName);
  },
};

export default Features;
